import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import HeaderRec from '../../header/headerRec';
import SharePopup from '../../commun/SharePopup';
import MissionTabs from '../../commun/MissionTabs';
import MissionInfo from '../../commun/MissionInfo';
import ProfilRecherche from '../../commun/ProfilRecherche';
import InfosComplementaires from '../../commun/InfosComplementaires';
import ContactCard from '../../commun/ContactCard';
import InfoCard from '../../commun/InfoCard';
import TalentCard from '../../commun/TalentCard';
import ActionCandidater from '../../commun/ActionCandidater';
import '../../Entreprise/Detailsmission/Detailsmission.css';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer'
import LoadingPopup from "../../commun/LoadingPopup";

const DetailMission = () => {
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const { id } = useParams();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const [mission, setMission] = useState(null);
  const [editedMission, setEditedMission] = useState({});
  const [activeTab, setActiveTab] = useState('mission');
  const [selectedMission, setSelectedMission] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [candidatures, setCandidatures] = useState([]);
  const [entreprise, setEntreprise] = useState(null);

  const fetchMission = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/missions/${id}`);
      const data = await res.json();
      setMission(data);
      setEditedMission(data);
      fetchEntreprise(data.createdBy);

    } catch (err) {
      console.error('Failed to fetch mission:', err);
    }
  };
  const fetchEntreprise = async (userId) => {
    try {
      const res = await fetch(`${API_BASE}/api/entreprise/profil/${userId}`);
      const data = await res.json();
      setEntreprise(data);
    } catch (err) {
    }
  };
  const fetchFavorites = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/recruteur`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { userId: userId }
      });
      const favIds = response.data.map(m => m._id);
      setFavorites(favIds);
    } catch (err) {
      console.error('Failed to fetch favorites:', err);
    }
  };

  const fetchCandidatures = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/candidatures/missionR/${id}/${userId}`);
      const data = await res.json();
      setCandidatures(data);
    } catch (err) {
      console.error("Erreur lors du chargement des candidatures:", err);
    }
  };

  useEffect(() => {
    fetchMission();
    fetchFavorites();
    fetchCandidatures();
  }, [id, authToken, API_BASE, userId]);

  // Refresh mission if candidatures change
  useEffect(() => {
    if (id) {
      fetchMission();
    }
  }, [candidatures]);

  const toggleFavorite = async (missionId) => {
    try {
      await axios.post(
        `${API_BASE}/api/recruteur/favorites/${missionId}?userId=${userId}`,
        {},
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      setFavorites(prev =>
        prev.includes(missionId)
          ? prev.filter(id => id !== missionId)
          : [...prev, missionId]
      );
    } catch (err) {
      console.error("Erreur lors du changement de favori :", err);
    }
  };

  if (!mission) return      
    <LoadingPopup
      open={!mission}
      message="Chargement..."
    />;

  return (
    <div className="entreprise-page">
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />
      <main className="pageContainer">
  <div className="contentWrapper">
    <div className="contentGrid">
      
      {/* ✅ Colonne de gauche */}
      <aside className="leftColumn">
  <div className="contactCardContainer">
    <ContactCard mission={editedMission} editable={false} utilisateur={mission.utilisateur} />
    <div className="actionCandidaterWrapper">
      <ActionCandidater
        mission={mission}
        candidatures={candidatures}
        onClick={() => {
          navigate(`/recruteur/travailler-mission/${mission._id}`);
        }}
      />
    </div>
  </div>
</aside>


      {/* ✅ Colonne principale */}
      <section className="mainColumn">
        <div className="missionContent">
          <MissionTabs activeTab={activeTab} setActiveTab={setActiveTab} viewerType="recruteur" />

          {activeTab === 'mission' && (
            <MissionInfo
              mission={mission}
              editedMission={editedMission}
              editable={false}
              isRecruteurView={true}
              favorites={favorites}
              toggleFavorite={toggleFavorite}
              setSelectedMission={setSelectedMission}
              showActionButtons={false}
              entrepriseLogo={entreprise?.logo}
            />
          )}

          {activeTab === 'profil' && (
            <ProfilRecherche
              editedMission={editedMission}
              editable={false}
              showActionButtons={false}
              entrepriseLogo={entreprise?.logo}
            />
          )}

          {activeTab === 'infos' && (
            <InfosComplementaires candidatures={candidatures} viewerType="recruteur" />
          )}
        </div>
      </section>

      {/* ✅ Colonne de droite */}
      <aside className="sideColumn">
       

        <InfoCard
  mission={editedMission}
  editable={false}
/>


        {/* ✅ Talents suggérés */}
        <TalentCard missionId="id_de_la_mission" />


      </aside>
    </div>
  </div>
</main>


      {selectedMission && (
        <SharePopup
          shareUrl={`${process.env.REACT_APP_FRONTEND_BASE_URL}/Recruteur/Details/${selectedMission._id}`}
          onClose={() => setSelectedMission(null)}
        />
      )}
            <Chatbox userRole="recruteur" />
                         <Footer />

    </div>

  );

};

export default DetailMission;
